<template>
  <v-card outlined class="d-flex flex-column full_height dashboard-box mb-2" :max-width="maxWidth">
    <v-card-text class="pa-0">
      <div class="d-flex justify-space-between">
        <div>
          <div class="text-h2 mb-1 text-left">
            {{ title }}
          </div>
          <div class="text-body-small grey-darken-2--text text-left" v-html="text" />
          <div v-if="shouldShowOutageText" class="text-body-small error--text text-left mt-1 mb-1">
            {{ outageLabel }}
          </div>
        </div>
        <div class="mt-1">
          <v-img eager width="48" height="48" :src="$asset(`img/icons/${icon}.svg`)" contain />
        </div>
      </div>
      <div class="text-left">
        <div v-for="(button, index) in buttons" :key="index">
          <span v-if="button.subtitle">{{ button.subtitle }}</span>
          <v-btn
            :disabled="isButtonDisabled(button) || disabled"
            height="40px"
            width="100%"
            :class="{ 'mb-2': buttons.length > 1 }"
            color="tetrary"
            :href="button.link"
            :target="button.link ? '_blank' : undefined"
            @click="button.action === undefined ? () => {} : button.action()"
          >
            {{ button.text }}
          </v-btn>
        </div>
      </div>
    </v-card-text>
    <v-spacer />
  </v-card>
</template>

<script>
export default {
  name: 'SupportBox',
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
    maxWidth: { type: [String, Number], required: false },
    buttons: { type: Array, required: false, default: () => [] },
    disabled: { type: Boolean, required: false, default: false },
    outage: {
      type: Object,
      required: false,
      default: () => ({
        active: false,
        dateISO: null,
        showTextAlways: false,
        i18nKey: 'dashboard.supportBox.unavailableOn'
      })
    }
  },
  computed: {
    outageDateObj() {
      if (!this.outage?.dateISO) {
        return null;
      }
      const date = new Date(this.outage.dateISO);
      return isNaN(date.getTime()) ? null : date;
    },
    isOutageToday() {
      if (!this.outageDateObj) {
        return false;
      }
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const date = now.getDate();
      const start = new Date(year, month, date, 0, 0, 0);
      const end = new Date(year, month, date, 23, 59, 59, 999);
      return this.outageDateObj >= start && this.outageDateObj <= end;
    },
    shouldShowOutageText() {
      if (!this.outage) {
        return false;
      }
      if (!this.outage.showTextAlways) {
        return false;
      }
      return !!this.outage.active;
    },
    outageLabel() {
      if (!this.outageDateObj) {
        return this.$t(this.outage?.i18nKey || 'dashboard.supportBox.unavailableOn', { date: '' });
      }
      const locale = this.$i18n?.locale || 'cs';
      const formatted = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(this.outageDateObj);
      return this.$t(this.outage?.i18nKey || 'dashboard.supportBox.unavailableOn', {
        date: formatted
      });
    }
  },
  methods: {
    isButtonDisabled(button) {
      const kind = button.kind || button.type || null;
      if (!kind) {
        return false;
      }
      if (kind === 'phone' && this.isOutageToday) {
        return true;
      }
      return false;
    }
  }
};
</script>
